exports.events = {
  add: function (target, evt, cb) {
    target.addEventListener(evt, cb);
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./js/events.js
 ** module id = 3
 ** module chunks = 0
 **/